
<template>
    <div>
    <el-dialog title="员工详情" @close="close" width="30%" :visible.sync="dialogFormVisible">
        <el-row class="info_box">   
            <el-col :span="24" style="text-align: left;">
                <img :src="avatar" style="width: 80px;border-radius: 50%;">
            </el-col>
               
            <el-col :span="24" style="text-align: left;">所属部门 : {{department}}</el-col>
            <el-col :span="24" style="text-align: left;">员工名称 : {{name}}</el-col>
            <el-col :span="24" style="text-align: left;">手机号码 : {{phone}}</el-col>
            <el-col :span="24" style="text-align: left;">入企信息 : {{company(companyAuthStatus)}}</el-col>
            <el-col :span="24" style="text-align: left;">员工状态 : {{isworkstate(status)}}</el-col>
        </el-row>
        <div slot="footer" class="dialog-footer">
            <el-button class="filter-item filter-item1" size="mini" @click="agreecompamy" type="primary" icon="el-icon-circle-close-outline"  :disabled = "coldderail">同意
            </el-button>
            <el-button class="filter-item filter-item1" size="mini" @click="noagreecompamy" type="primary" icon="el-icon-circle-check-outline"  :disabled = "coldderail">拒绝
            </el-button>
        </div>
    </el-dialog>
    </div>
</template>
<script>
    import {stop,getpersonnel} from '@/api/admin/workerUser'
    import {addcompany} from '@/api/admin/user'
    import {getImgLink} from '@/config/env'
    import {mapGetters} from 'vuex'
    import {dateOnce} from '@/util/dateT'
    import {objKeySort } from '@/util/ajaxsign'
    export default {
        data() {
            return {
                userId : '',    
                dialogFormVisible : false,
                dictionarylist : [],
                avatar : '',
                department : '',
                name : '',
                phone : '',
                status : '',
                companyAuthStatus : ''
            }
        },
        created() {},
        mounted() {},
        methods: {
            //刷新列表操作
            refresh(){
                this.getCompanyInfo();
                this.$emit('refresh');
            },
            //设置展示
            setsataus(userId,infodetail){
                this.dialogFormVisible = true;
                this.userId = userId;
                this.infodetail = infodetail;
                this.getCompanyInfo(infodetail);
            },

            //项目详情数据请求
            getCompanyInfo(){
                getpersonnel(objKeySort({userId:this.userId})).then(response => {
                    this.avatar = response.data.data.avatar?getImgLink(response.data.data.avatar):response.data.data.headimgurl?response.data.data.headimgurl:'/img/default-avatar.png';
                    this.department = response.data.data.department?response.data.data.department:'未设置';
                    this.name =  response.data.data.name;
                    this.phone =  response.data.data.phone;
                    this.status = response.data.data.status;
                    this.companyAuthStatus = response.data.data.companyAuthStatus
                    if(this.companyAuthStatus==1 || this.companyAuthStatus==-1){
                        this.coldderail = true;
                    }else{
                        this.coldderail = false;
                    }
                })
            },

            //默认时间
            settime(data){
                return dateOnce(data)
            },
           
              //同意加入
            agreecompamy(){
                addcompany(objKeySort({userId:this.userId,state : 1})).then(response =>{
                    this.refresh()
                })
            },
            
            //拒绝加入
            noagreecompamy(){
                addcompany(objKeySort({userId:this.userId,state : 0})).then(response =>{
                    this.refresh()
                })
            },
            //取消回调
            close(){
                console.log("取消")
            },
      
            isworkstate(data){
                console.log(data);
                if(data == 1){
                    return  '审核中'
                }else if(data == 2){
                    return  '已认证'
                }else if(data == 3){
                    return  '拒绝审核'
                }else if(data == 4){
                    return  '已冻结'
                }else{
                    return  '未认证'
                }
            },
            company(data){
                if(data == 1){
                     return  '已加入'
                }else if(data == -1){
                     return  '被拒绝'
                }else{
                     return  '申请加入'
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
.container{
    min-width:800px;
    max-width:900px;
}
.form_layout_items{
    display:flex
}
.select_option{
    position: absolute;
    z-index: 22;
    width: 150px !important;
    right: 0;
    top: 0;
}
.el-table ::v-deep .el-table__row:nth-child(even) {
    background-color: #F6F9FF !important;
  }
  .form_layout_item{
      width:50%;
      border:1px solid #fff;
      height:80px;
  }
</style>